import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { harvestProofQueries } from '../queries/harvest-proof-queries';

import { useFiltersStore } from '@data-access';

export function useHarvestProofList() {
  const page = useFiltersStore.use['harvestProof']().pagination.pageIndex + 1;
  const sorting = useFiltersStore.use['harvestProof']().sorting;
  const filters = useFiltersStore.use['harvestProof']().filters;

  return useQuery({
    ...harvestProofQueries.list({ page, sorting, filters }),
    placeholderData: keepPreviousData,
  });
}
